import { RpcClient } from "@goblinhunt/cosmes/client";
import {
  CosmosBankV1beta1QueryBalanceResponse,
  CosmosBankV1beta1QueryBalanceService,
  CosmosTxV1beta1GetTxResponse,
  CosmosTxV1beta1ServiceGetTxService,
  CosmwasmWasmV1QuerySmartContractStateResponse,
  CosmwasmWasmV1QuerySmartContractStateService,
} from "@goblinhunt/cosmes/protobufs";

export async function querySmartContract(
  address: string,
  queryMsg: object
) {
  const res = await new Promise<CosmwasmWasmV1QuerySmartContractStateResponse>(
    (resolve, rej) =>
      RpcClient.newBatchQuery("https://terra-classic-rpc.publicnode.com:443")
        .add(
          CosmwasmWasmV1QuerySmartContractStateService,
          {
            address,
            queryData: new Uint8Array(Buffer.from(JSON.stringify(queryMsg))),
          },
          (err, res) => (err ? rej(err) : resolve(res))
        )
        .send()
  );
  return JSON.parse(Buffer.from(res.data).toString());
}
